module.exports = __webpack_public_path__ + "img/x-gray.2e80c65b.svg";